import { push } from "react-router-redux";
import { stopSubmit } from "redux-form";

import api from "../services/api";
import { showError } from "./common.actions";

export const FORGOT_PASSWORD_FORM = "forgotPassword";

export function resetPassword(email) {
  return dispatch => {
    api
      .forgotPassword(email)
      .then(() => {
        dispatch(push("/forgot-password/confirmation-page"));
      })
      .catch(error => {
        dispatch(stopSubmit(FORGOT_PASSWORD_FORM, error.response.data.errors));
        dispatch(showError(error.response.data.message));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/forgotPassword.actions.js